import { SHOW_FAVORITES_NOTIFICATION } from './constants'

export const showNotification = (type, data) => {
  if (!window) return

  const event = new CustomEvent(SHOW_FAVORITES_NOTIFICATION, { detail: { type, item: data }})
  window.dispatchEvent(event)
}
